/**
 * Dropdown menu listing bulk actions (v1: Mark as Done only).
 */
import { observer } from "mobx-react";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import "./rma-list-bulk-actions-menu.scss";

interface IProps {
    onMarkDone: () => void;
    onClose: () => void;
}

const RmaListBulkActionsMenu: React.FC<IProps> = observer(({ onMarkDone, onClose }) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-returns-page";

    return (
        <div className="rma-list-bulk-actions-menu" role="menu">
            <div className="rma-list-bulk-actions-menu__header">
                {getTranslation("BULK_ACTIONS_MENU_HEADER", scope)}
            </div>
            <button
                type="button"
                className="rma-list-bulk-actions-menu__item"
                role="menuitem"
                onClick={onMarkDone}
            >
                {getTranslation("BULK_ACTION_MARK_AS_DONE", scope)}
            </button>
            <button
                type="button"
                className="rma-list-bulk-actions-menu__backdrop"
                aria-label={getTranslation("BULK_MARK_DONE_CONFIRM_CANCEL", scope)}
                onClick={onClose}
            />
        </div>
    );
});

export default RmaListBulkActionsMenu;
